module.exports = __webpack_public_path__ + "media/src/images/page02_sub_001_zu0301-d2e487d95623d3e405b135308294a7ab.png";